export const ROLE_OPTIONS = ['O', 'C', 'V'] as const;
export type RoleType = (typeof ROLE_OPTIONS)[number];

export type WorkspaceRole = {
    uid: string;
    roleType: RoleType;
    name: string;
    login: string;
};

type WorkspaceRoleApiItem = {
    uid?: string | null;
    roleType?: string | null;
    name?: string | null;
    login?: string | null;
};

type WorkspaceRolesApiResponse = WorkspaceRoleApiItem[];

const VALID_ROLE_TYPES = new Set(['O', 'C', 'V']);

const hasUid = (item: WorkspaceRoleApiItem): item is WorkspaceRoleApiItem & { uid: string } =>
    typeof item.uid === 'string';

const transformRole = (item: WorkspaceRoleApiItem & { uid: string }): WorkspaceRole => ({
    uid: item.uid,
    roleType: VALID_ROLE_TYPES.has(item.roleType ?? '')
        ? (item.roleType as WorkspaceRole['roleType'])
        : 'V',
    name: item.name ?? '',
    login: item.login ?? '',
});

export interface WorkspaceRolesQueryArg {
    workspaceId: string;
    tenantId: string;
}

export const workspaceRolesQuery = {
    query: ({ workspaceId, tenantId }: WorkspaceRolesQueryArg) => ({
        url: `/mp/1/listroles?pid=${encodeURIComponent(workspaceId)}&tenantId=${encodeURIComponent(tenantId)}`,
        method: 'get',
    }),
    transformResponse: (response: WorkspaceRolesApiResponse): WorkspaceRole[] =>
        (response ?? []).filter(hasUid).map(transformRole),
};

export interface AssignRoleArg {
    workspaceId: string;
    tenantId: string;
    userId: string;
    roleType: RoleType;
}

export const assignRoleMutation = {
    query: ({ workspaceId, tenantId, userId, roleType }: AssignRoleArg) => ({
        url: `/mp/1/assignrole?role=${roleType}&uid=${encodeURIComponent(userId)}&pid=${encodeURIComponent(workspaceId)}&tenantId=${encodeURIComponent(tenantId)}`,
        method: 'post',
    }),
};
